<template>
  <div id="contacto"  >
      
      <form class="container">
        <h1>CONTACTO</h1>  
        
        
        <input class="u-full-width" type="text" placeholder="Nombre" v-model="formData.nombre">
        <label >Nombre</label>
        <input class="u-full-width" type="email" placeholder="test@mailbox.com" v-model="formData.email">
        <label >Mail</label>
        
        
        
        <textarea class="u-full-width" placeholder="Hola, necesito …" v-model="formData.texto" ></textarea>
        <label >Consulta</label>
        <vue-recaptcha sitekey="6LevRawZAAAAAICSDZaqCpdWdJlz0GB_P9lFnFPE" :loadRecaptchaScript="true">
          <button class="button-primary" type="button" @click="enviar">Enviar</button>
        </vue-recaptcha>
        <br/><br/>
        <div class="iconos-fondo">
          <a href="https://wa.me/5492614708094"><img src="/img/contacto-argentina.svg"/></a>
          <a href="https://wa.me/569676023421"><img src="/img/contacto-chile.svg"/></a>
          <a href="mailto:info@stbalanzas.com"><img src="/img/contacto-mail.svg"/></a>
        </div>
        <div >
            
            
        </div>
      </form>
      
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
export default {
  components:{
    VueRecaptcha
  },
  data(){
    return {
      formData:{

      }
    };
  },
  methods:{
    enviar(){
      let url = "http://stbalanzas.com/send.php";
      fetch(url, {
        method: 'POST',
        mode: 'no-cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'  
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(this.formData)
      })
      .then(res => {
        window.alert('Correo Enviado');
        this.formData = {};
      })
      .catch(error => {
        console.error(error);
      })

    },

  }

}
</script>


<style >
  #contacto{
    background-color: #004A99;
    color: #fefefe;
  }
  .iconos-fondo img{
    margin: 10px
  }
  #contacto input,
  #contacto textarea
  {
    color: #004A99;
  }
  
</style>